import { Component } from '@angular/core';
import { EvLogoLoaderComponent } from '../ev-logo-loader/ev-logo-loader.component';
@Component({
    selector: 'loading-page',
    imports: [EvLogoLoaderComponent],
    templateUrl: './loading-page.component.html',
    styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {}
